import { createSelector } from 'reselect';

import {
  keyifyParamsForFiltersRequest,
} from '@Containers/ResultsFilters/ResultsFiltersComponents/ListOfFilters/ListOfFiltersSelectors';
import {
  selectedOptionTitles as selectedOptionTitlesSelector,
  selectedOptionsNameValueObjectsArray as selectedOptionsNameValueObjectsArraySelector
} from '@Containers/StructureOptions/StructureOptionsSelecors';

import { structureFilterReducerKey } from './StructureFilterConstants';


export function structureFilterState (state) {
  return state.get(structureFilterReducerKey);
}

export function drawingFactory (keySelector = keyifyParamsForFiltersRequest) {
  return createSelector(
    [structureFilterState, keySelector],
    (structureFilterState, key) => {
      return structureFilterState.get(key);
    }
  );
}

export const drawing = drawingFactory();

export function selectedOptionTitles (state) {
  const id = keyifyParamsForFiltersRequest(state);

  return selectedOptionTitlesSelector(state, { id });
}

export function selectedOptionsNameValueObjectsArray (state) {
  const id = keyifyParamsForFiltersRequest(state);

  return selectedOptionsNameValueObjectsArraySelector(state, { id })
}
